'use strict';
const mindmupProfile = require('./mindmup-profile'),
	PROVIDER_NAME = 'crowdlink';
module.exports = function CrowdlinkAuthenticator({goldApi, authenticationModel, context}) {
	if (!goldApi || !authenticationModel || !context) {
		throw new Error('invalid-args');
	}
	const clean = ({fileId, password, displayName, externalContextId}) => {
			const params = {fileId, displayName};
			if (password) {
				params.password = password;
			}
			if (externalContextId) {
				params.externalContextId = externalContextId;
			}
			return params;
		},
		authenticate = async ({fileId, password, displayName, externalContextId}) => {
			if (!fileId || !displayName) {
				throw new Error('invalid-args');
			}
			authenticationModel.authenticationStarted();
			try {
				const license = await goldApi.exec(`file/${context}/authenticate`, clean({fileId, password, displayName, externalContextId})),
					mmProfile = mindmupProfile(PROVIDER_NAME, displayName, license);
				authenticationModel.authenticatedProfile(() => mmProfile);
				return mmProfile;
			} catch (reason) {
				authenticationModel.authenticationFailed(reason);
				throw reason;
			}
		};
	Object.freeze(Object.assign(this, {authenticate}));
};
